const styles = (theme) => ({
  contentContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    position: "relative",
    overflowY:"auto",
    padding: '14 40 14 24',
  },
  locationLabel: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '16px',
    paddingBottom: 20,
    paddingTop: 20,
  },
  paddingBottom10: {
    marginBottom: 10
  },
  dataNotFound: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    letterSpacing: '0.25px',
    flex: 1,
    flexWrap: 'wrap'
  },
  prevLocationContainer: {
    display: "flex",
    flexDirection: "column",
    position: 'relative',
    padding: '0px',
    flex: 1
  },
  loading: {
    padding: 0
  }
});

export default styles;
